import { createInstance } from 'app/localforage'

/**
 * Replaces the `vue-localforage` package, which is Vue 2-only.
 *
 * It injected `$getItem` / `$setItem` / `$removeItem` as thin promise wrappers
 * over localforage's default instance. Six components use them for UI
 * preferences — the kit icon results view, filter family, dismissed
 * subscription notices, and the component-state memo mixin.
 *
 * `createInstance()` is called with no configuration deliberately: that yields
 * localforage's default store (name "localforage", store "keyvaluepairs"),
 * which is where the old plugin wrote. A named instance would be a fresh store,
 * silently resetting every existing user's saved preferences. Going through
 * `app/localforage` rather than localforage directly also keeps its fallback
 * for browsers where no driver is supported.
 */
const storage = createInstance()

export default (vueInstance) => {
  vueInstance.config.globalProperties.$getItem = (key) => storage.getItem(key)
  vueInstance.config.globalProperties.$setItem = (key, value) => storage.setItem(key, value)
  vueInstance.config.globalProperties.$removeItem = (key) => storage.removeItem(key)
}
